import React from 'react';

import { ADMIN_DASHBOARD } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { HistoryIcon } from '@kallidus/common';

const HistoryPage = React.lazy(() => import('../../../pages/Admin/History/HistoryPage'));

export default {
  label: 'navigation.admin.history',
  group: ADMIN,
  to: '/administration/history',
  route: '/administration/history',
  component: HistoryPage,
  icon: <HistoryIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  area: ADMIN_DASHBOARD,
  hasNavBar: true,
};
